/**
 * Implements a KendoUI DatePicker as a Marionette Behavior.
 */

import Marionette from "backbone.marionette";

import "kendo.core";
import "kendo.fx";
import "kendo.popup";
import "kendo.calendar";
import "kendo.datepicker";

class DatePicker extends Marionette.Behavior {
  defaults() {
    return {
      // behavior defaults
      selector: ".rvc-datepicker",
      opts: {
        animation: false,
        format: "MM/dd/yyyy",
        parseFormats: ["MM/dd/yyyy", "MMMM yyyy"],
      },
    };
  }

  events() {
    return {
      "shown.bs.dropdown": "_onDropdownShown",
    };
  }

  initialize() {
    // merge defaults and user options
    _.defaults(this.options.opts, this.defaults.opts);

    // debounced version of createInstance()
    this.instantiate = _.debounce(this._createInstance, 25);
  }

  /**
   * Instantiates behavior when view is rendered.
   *
   * This will not instantiate date fields within hidden components, like
   * filters. See _onDropdownShown handler.
   */
  onRender() {
    this.instantiate();
  }

  /**
   * Instantiates behavior when the containing drop down is shown.
   * Takes care to only do this once per view instance.
   */
  _onDropdownShown() {
    if (!this.instantiated) {
      this.instantiate();
    }
  }

  _createInstance() {
    const $el = this.$(this.options.selector);
    if ($el.length) {
      $el.each((index, input) => {
        const $el = $(input);
        // combine default and custom options
        const options = Object.assign(
          {},
          this.options.opts,
          this._getConfig($el)
        );

        // create instance
        this.api = null;
        try {
          const instance = $el.kendoDatePicker(options);
          this.api = instance.getKendoDatePicker();
        } catch (err) {
          console.error(err.stack);
        }

        this.instantiated = true;
      });
    }
  }

  /**
   * Pulls data-* attributes from markup and returns them as config params
   */
  _getConfig($el) {
    const { value = null, min = null, max = null } = $el.data();

    const config = {};

    if (!_.isEmpty(value)) {
      config.value = new Date(value);
    }

    if (!_.isEmpty(min)) {
      config.min = new Date(min);
    } else {
      config.min = "1/1/1900";
    }

    if (!_.isEmpty(max)) {
      config.max = new Date(max);
    } else {
      config.max = new Date();
    }

    return config;
  }
}

export { DatePicker as default };
